import { UnitStatusSearchForm } from '@mark43/cad-api';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function EventRelatedInformationFiltersSummary({ form }: { form: UnitStatusSearchForm }) {
    return (
        <FiltersSummary title="Event Related Information">
            <FilterSummary label="CAD Event #" stringValue={form.eventNumber} />
            <FilterSummary label="Call Origins" options={form.eventOrigins} />
            <FilterSummary label="Calls For Service" options={form.callForServices} />
            <FilterSummary label="Priority Levels" options={form.priorities} />
        </FiltersSummary>
    );
}
